import React, { useState, useEffect } from 'react';
import { Box, Radio, RadioGroup, Stack, Button, Flex } from '@chakra-ui/react';
import { path } from "ramda";
import { useUpsertDataMutation, useUpdateDecisionMutation } from "../app/api";
import { useSelector } from 'react-redux';

export const SingleChoice = ({ items, filtered, decision_id, participant_id, activity_id,
  order_nr, next_to_show, show_until, all_done, data_input, done_item,
  next_done_item, next_btn_visible, is_last }) => {

  const [upsertData] = useUpsertDataMutation();
  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui", "ui_texts"]));
  const [selected, setSelected] = useState(null);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    const chosen = filtered.find(r => r.value_number === 1);
    setSelected(chosen ? String(chosen.input_id) : null);
  }, [filtered]);

  const handleSelect = (itemId) => {
    setSelected(itemId);
    setChanged(true);
  };

  const handleSubmit = () => {
    const numId = Number(selected);
    const data = items.map(item => {
      const existing = filtered.find(r => r.input_id === item.id);
      return {
        value_number: item.id === numId ? 1 : 0,
        ...(existing ? { id: existing.id } : {}),
        input_id: item.id,
        decision_id, participant_id, activity_id
      };
    });
    upsertData(data);
    setChanged(false);
  };

  const hide_next_btn = (done_item === null || data_input == null)
    ? (show_until > order_nr)
    : !next_btn_visible;

  return items.length ? (
    <Box>
      <RadioGroup value={selected || ""} onChange={handleSelect}>
        <Stack spacing={2} mt={2}>
          {items.map(item => (
            <Radio key={item.id} value={String(item.id)} colorScheme="teal">
              {item.value_text}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      <Flex mt={3} gap={2}>
        <Button size="md" colorScheme="teal" onClick={handleSubmit} isDisabled={!changed || !selected}>
          {texts.save}
        </Button>
        {(hide_next_btn || !all_done) ? null : (
          <Button size="md" colorScheme="blue" onClick={() => {
            moveForward({
              id: decision_id,
              done: order_nr,
              done_item: next_done_item,
              show_until: next_to_show
            });
          }}>
            {texts.next}
          </Button>
        )}
      </Flex>
    </Box>
  ) : null;
};
